<template>
  <b-modal
    v-model="modal.show"
    size="lg"
    title="Batch File List"
    ok-only
    ok-variant="secondary"
    ok-title="Close"
    body-class="p-0"
    @ok.prevent="closeModal"
  >
    <div
      v-if="!loading"
      class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center"
    >
      <div class="d-flex justify-content-end">
        <b-button
          size="sm"
          class="ml-1 mr-3"
          @click="onAddNewBatchFileClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Add new file
        </b-button>
      </div>
    </div>
    <content-spinner
      :show="loading"
      :fullscreen="true"
    />
    <b-row v-if="!loading">
      <b-col cols="12">
        <complex-table-view
          :is-file-manipulation-controller="true"
          :small="true"
          :fields="fields"
          :items="batch.batchFiles"
          :total-rows="batch.batchFiles && batch.batchFiles.length"
          :modal-name="`null`"
          :action-buttons="actionButtons"
          @on-edit="onEditClick"
          @on-delete="onDeleteClick"
        />
      </b-col>
    </b-row>
    <add-edit-batch-file-modal
      v-if="isAddEditBatchFileModalOpen"
      @on-update="updateBatchList"
    />
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ComplexTableView from '../../../../core/components/complex-table/components/ComplexTableView';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import AddEditBatchFileModal from './AddEditBatchFileModal';

const {mapState, mapActions} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'BatchFileListViewModal',
  components: {
    AddEditBatchFileModal,
    ComplexTableView,
    ContentSpinner,
  },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'batchFileName',
          name: 'batchFileName',
          label: 'Name',
        },
      ],
      actionButtons: {
        delete: true,
      },
    };
  },
  computed: {
    ...mapState({
      modal: state => state.batchFileListModal,
      batch: state => state.batchFileListModal.data.batch || {},
      isAddEditBatchFileModalOpen: state => state.addEditBatchFileModal.show,
    }),
  },
  methods: {
    ...mapActions([
      'showAddEditBatchFileModal',
      'hideBatchFileListModal',
      'deleteBatchFile',
      'getBatchList',
    ]),
    async updateBatchList() {
      this.$emit('on-update');
    },
    closeModal() {
      this.hideBatchFileListModal();
    },
    onEditClick(batchFile) {
      this.showAddEditBatchFileModal({
        batch: this.batch,
        batchFile,
      });
    },
    async onDeleteClick(index) {
      const confirmed = await this.$confirm(
        'Deleting Record...',
        'You are deleting record. Are you sure you want to continue?',
      );

      if (confirmed) {
        const batchFile = this.batch.batchFiles.find((b, idx) => idx === index);

        const {success, body} = await this.deleteBatchFile(batchFile);
        if (success) {
          this.$toasted.success('Deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    onAddNewBatchFileClick() {
      this.showAddEditBatchFileModal({
        batch: this.batch,
      });
    },
  },
};
</script>